import React from 'react'
import AppStoreDownloadItem from '../component/AppStoreDownloadItem/AppStoreDownloadItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons'

import QuoteSection from '../component/QuoteSection/QuoteSection'
import './EaseAppsInfoComponent.css' // 使用相同的 CSS 文件

import EaseStarLogo from '../../../assets/logos/easestar.png'
import EaseSoundLogo from '../../../assets/logos/easesound.png'

function EaseSoundInfoComponent() {
  // 更改组件名称
  return (
    <div className="ease-star-info">
      <QuoteSection
        quoteText="EaseSound: Your Personal Soundtrack, Anywhere."
        quoteAuthor="App Creators"
      />

      <section>
        <h4>Relive the Drama, Anytime, Anywhere</h4>
        <p>
          Have you ever admired the epic poses of anime or game characters as
          they shout their unforgettable catchphrases? Maybe you've even tried
          mimicking them—striking the pose but hesitating to voice the line out
          loud.
        </p>
        <p>That's where EaseSound steps in.</p>
        <p>
          With EaseSound, you can upload the iconic MP3 audio clips of your
          favorite characters to your Apple Watch. Pair it with a flick of your
          wrist, and let your hand movements bring those legendary lines to
          life—no words required!
        </p>
      </section>
      <section>
        <h4>Core Features That Make the Magic Happen</h4>
        <ul>
          <li>
            <strong>Seamless MP3 Transfer:</strong> Download the character voice
            lines you love and transfer them from your iPhone to your Apple
            Watch. Your watch becomes your soundboard for epic moments.
          </li>
          <li>
            <strong>Gesture-Activated Playback:</strong> Strike the pose, flick
            your wrist, and let the sound do the talking. EaseSound brings the
            drama without you needing to say a word.
          </li>
          <li>
            <strong>Custom Cover Images:</strong> Earn points through your
            interactions and redeem them for unique profile frames that reflect
            your style.
          </li>
        </ul>
      </section>
      <footer>
        <h4>Perfect for Anime and Gaming Fans</h4>
        <p>
          EaseSound isn't just an app—it's a way to express your love for the
          characters that inspire you. Whether you're channeling your favorite
          hero or reliving a nostalgic gaming moment, EaseSound lets you bring
          their energy into the real world.
        </p>
        <AppStoreDownloadItem
          appName="EaseSound"
          description="A Small Tool That Sparks Big Joy"
          buttonText="Get"
          logoSrc={EaseSoundLogo}
          url="https://apps.apple.com/us/app/easesound/id6737292686"
        />
      </footer>
    </div>
  )
}

export default EaseSoundInfoComponent // 更改导出名称
